
import * as moment from 'moment';

angular.module("common").constant("MOMENT", moment);
